import React, { useContext } from 'react'
import { DemoContext } from '../lib/DemoProvider'
import Button from '@react/react-spectrum/Button'
import analytics from '../config/analytics'

export default function DemoHtml () {
    const { page } = useContext(DemoContext)
    // console.log(`process.env.NODE_ENV : ${process.env.NODE_ENV}`)
    const fileNames = [
        'person001',
        'person003',
        'person005',
        'antique001',
        'antique002',
        'antique003',
        'accessories001',
        'accessories002',
        'accessories003',
        // 'as001',
        // 'as002',
        // 'as003'
    ]

    function editCutout(target, name) {
        analytics.sendEventName('click', `${page}:${name}:downloadCutout`)
        window.editCutout(target)
    }

    // function saveCutout(target, name) {
    //     analytics.sendEventName('click', `${page}:${name}:downloadCutout`)
    //     window.saveCutout(target, name)
    // }

    function downloadCutout(target, name) {
        analytics.sendEventName('click', `${page}:${name}:downloadCutout`)
        window.downloadCutout(target, name)
    }

    const compos = fileNames.map( name => {
        const filePath = `${process.env.REACT_APP_DISDK_PROD_URL}/demo/remove-background/html/asset/${name}`
        return <div className="adobe-table" key={`${filePath}.jpg`}>
            <remove-background
                image-data={`${filePath}.jpg`}
                cutout-data={`${filePath}.png`}>
            </remove-background>
            <div className='adobe-download-buttons'>
                <Button variant="action" onClick={ e => editCutout(e.target, name)}>Edit</Button>
                {/* <Button variant="action" onClick={ e => saveCutout(e.target, name)}>Save</Button> */}
                <Button variant="action" onClick={ e => downloadCutout(e.target, name)}>Download</Button>
            </div>
        </div>
    })
    return <div className="adobe-app-wrap">
        {compos}
    </div>
}
